import React from "react";
import { Link } from "react-router-dom";
import { IUser } from "@eagerdog/interfaces";

import styles from  "./UserCard.module.scss";

interface IProps {
  user: IUser;
  isPremium?: boolean;
  /** Render the "Premium / Basic Member" line. Off while Dog Owner Premium is retired. */
  showPremiumBadge?: boolean;
  isGuest?: boolean;
}

const UserCard: React.FC<IProps> = (props) => {
  const { user, isPremium, showPremiumBadge = true, isGuest } = props;
  const initial = isGuest ? "G" : (user.display_name || user.first_name || "?").charAt(0).toUpperCase();
  const name = isGuest ? "Guest" : (user.display_name || `${user.first_name || ""} ${user.last_name || ""}`.trim() || "Guest");

  return (
    <div className={isPremium ? `${styles.UserCard} ${styles.premium}` : `${styles.UserCard}`}>
        <div className={styles.portrait}>
          <span>{initial}</span>
        </div>
        <div className={styles.inner}>
            <div className={styles.name}>{name}</div>
            {!isGuest && showPremiumBadge && <div className={styles.membership}>{isPremium ? "Premium" : "Basic"} Member</div>}
            {isGuest && <div className={styles.membership}>Not Logged In</div>}
            {isGuest
              ? <Link to="/login">Login →</Link>
              : <Link to="/account">View Account →</Link>
            }
        </div>
    </div>
  );
};

export default UserCard;